import React from 'react';
import * as S from "./InboundCallWidget.styles";

const InboundCallWidget = ({
  inboundCallText,
  inboundCallNumber,
  isForm = false
}: {
  inboundCallText: string | undefined;
  inboundCallNumber: string | undefined;
  isForm: boolean;
}) => {
  return (
    <S.InBoundCall>
      <div className={`${isForm ? 'inboundCallBox' : 'pushRight inboundCallBox'}`}>
      <div className={`${isForm ? 'inboundCallInfo' : 'inboundCallInfo floatRight'}`}>
        <div className="inboundCallText">
          {inboundCallText}
        </div>
        <div className="inboundCallNumberArea">
          <span className="inboundCallNumberText">
            {inboundCallNumber}
          </span>
        </div>
      </div>
    </div>
    </S.InBoundCall>
  );
};

export default InboundCallWidget;


